<template>
  <div
    v-if="showSai"
    class="pvd-container container-divider"
  >
    <h2 class="pvd-heading-L">
      {{ pd_content.rc_strategic_adviser_section.section_header }}
    </h2>
    <p class="m-small-top">
      <VueShowdown
        :extensions="[formatMarkdown]"
        :markdown="pd_content.rc_strategic_adviser_section.paragraph_lede"
      />
    </p>
    <br>
    <p class="m-small-top">
      <VueShowdown
        :extensions="[formatMarkdown]"
        :markdown="pd_content.rc_strategic_adviser_section.paragraph_lede_two"
      />
    </p>
    <br>
    <apx-toggle
      id="toggleSAI"
      help-size="small"
      :value="toggleValue"
      :yes-label="pd_content.rc_strategic_adviser_section.toggle_text_yes"
      :no-label="pd_content.rc_strategic_adviser_section.toggle_text_no"
      :group-label="pd_content.rc_strategic_adviser_section.toggle_label"
      :help-header="pd_content.rc_strategic_adviser_section.toggle_modal_helper_header"
      :help-body="pd_content.rc_strategic_adviser_section.toggle_modal_helper_body"
      stack
      @change="toggleChanged"
    />
    <br>
    <p class="m-small-top">
      {{ pd_content.rc_strategic_adviser_section.bullet_header }}
    </p>
    <ul class="pvd-list-bullet">
      <li>
        <VueShowdown
          :extensions="[formatMarkdown]"
          :markdown="pd_content.rc_strategic_adviser_section.bullet_two_text"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';

export default {
  name: 'StrategicAdviserProxyComponent',
  mixins: [dataHelper],
  props: {
    showSai: {
      type: Boolean,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      toggleValue: 'Yes',
    };
  },
  mounted() {
    const toggleSAI = document.querySelector('#toggleSAI');
    this.commitPrimaryUserData(!!toggleSAI, 'isSAIasAgent');

    toggleSAI.addEventListener('value-changed', (evt) => {
      const value = evt.detail === 'Yes';
      this.commitPrimaryUserData(value, 'isSAIasAgent');
    });
  },
  methods: {
    toggleChanged() {
      if (this.toggleValue === 'Yes') {
        this.toggleValue = 'No';
      } else if (this.toggleValue === 'No') {
        this.toggleValue = 'Yes';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  ul.pvd-list-bullet {
    li:before{
      content: none;
    }
    li ul{
      padding-left:0px;
      li{
        list-style-type: none;
      }
    }
  }

</style>
